import CarOutlined from '@ant-design/icons/CarOutlined';
import EnvironmentOutlined from '@ant-design/icons/EnvironmentOutlined';
import { t } from 'i18n';

const captains = {
  id: 'group-captains',
  title: t('Captains'),
  type: 'group',
  children: [
    { id: 'captains-list', title: t('Captains'), type: 'item', url: '/captains', icon: CarOutlined },
    { id: 'captain-tracking', title: t('Live Tracking'), type: 'item', url: '/captains/tracking', icon: EnvironmentOutlined }
  ]
};

export default captains;
